// extracted by mini-css-extract-plugin
module.exports = {"moreInformation":"style_moreInformation__3kZqYvNUv6wiIsLAe4KaKh"};